import { Reveal } from "@components/ui";
import documentIcon from "@assets/images/Frame-1618869485.svg";

const resources = [
  {
    title: "Home Gas Safety Checklist",
    description: "Quick guide for residential users",
  },
  {
    title: "Commercial Safety Audit Template",
    description: "Quick guide for facility managers",
  },
];

export function SafetyResourcesSection() {
  return (
    <section className="w-full bg-[#f1f1f1] overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:pt-[100px] lg:pb-[120px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-8 md:gap-12 font-albert-sans">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6 py-3 md:py-[12px]">
            <div className="flex flex-col gap-3">
              {/* Pill Badge */}
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.04em] uppercase w-fit">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Resources
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[56px] font-bold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
                Safety Resources & Downloads
              </h2>
            </div>
            <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-3 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors shrink-0 w-fit group">
              <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white whitespace-nowrap">
                Download All Resources
              </span>
              {/* Inline SVG Arrow */}
              <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.43 5.93L20.5 12L14.43 18.07" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3.5 12H20.33" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </button>
          </div>
        </Reveal>

        {/* Resource Cards */}
        <Reveal direction="up">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {resources.map((resource, index) => (
              <div
                key={index}
                className="group rounded-[16px] bg-white flex items-center gap-4 md:gap-8 py-5 px-4 md:py-6 md:pl-4 md:pr-6 border border-transparent hover:border-[#e8e9ed] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 cursor-pointer"
              >
                {/* Tinted Icon Container */}
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-[12px] bg-[#122d63]/8 flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-105">
                  <img
                    src={documentIcon}
                    alt=""
                    className="w-8 md:w-10 h-auto"
                  />
                </div>
                <div className="flex-1 flex flex-col gap-0.5 min-w-0">
                  <h3 className="text-[18px] md:text-[24px] lg:text-[28px] font-semibold tracking-[-0.04em] text-[#1e1f24]">
                    {resource.title}
                  </h3>
                  <p className="text-[14px] md:text-[18px] lg:text-[20px] tracking-[-0.04em] text-[#62636c]">
                    {resource.description}
                  </p>
                </div>
                {/* Inline SVG Download Icon */}
                <button className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#122d63]/8 flex items-center justify-center transition-all duration-300 group-hover:bg-[#122d63] group-hover:scale-110">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="transition-colors duration-300">
                    <path d="M12 15V3" stroke="#122d63" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors duration-300"/>
                    <path d="M8 11L12 15L16 11" stroke="#122d63" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors duration-300"/>
                    <path d="M20 21H4" stroke="#122d63" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors duration-300"/>
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
